export function getOffset(element) {
    element = element.getBoundingClientRect();
    const scrollPosition =
        (window.pageYOffset || document.documentElement.scrollTop) -
        (document.documentElement.clientTop || 0);
    return element.top + scrollPosition;
}

export function getUrlParameter(name) {
    name = name.replace(/\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(window.location.search);
    return results === null
        ? ''
        : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export function isEmail(email) {
    const re = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

export function initCopyEventGtm() {
    document.addEventListener('copy', () => {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'ContentInteraction',
                action: 'copy',
                value: document.getSelection().toString()
            });
        }
    });
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js